import React, { useState} from "react";
import { useTranslation } from "react-i18next";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext"; 
import { ProgressSpinner } from "primereact/progressspinner";
import { useForm  } from "react-hook-form"; 
import styled from "./Register.module.css";    
import SecurityApi from "../../services/SecurityApi";
import { useToast } from "./../../context/ToastContext"; 

const Register: React.FC = () => {
  const [username, setUsername] = useState("")
  const [name, setName] = useState("")
  const [email, setEmail] = useState("")
  const [phone, setPhone] = useState("")
  const [password, setPassword] = useState("")
  const [confirmPassword, setConfirmPassword] = useState("")
  const [departament, setDepartament] = useState("")
  const [position, setPosition] = useState("")
  const [groupId, setGroupId] = useState("")
  const [loading, setLoading] = React.useState(false); 
  const { t } = useTranslation("form"); 
  const { displayToast } = useToast();
  const { t: translateMessage } = useTranslation("messages"); 

  const methods = useForm();

  const { handleSubmit } = methods;  

  const onSubmit = async (): Promise<void> => {
    try {
      setLoading(true); 
      let response = await SecurityApi.Signin({
        Name: name,
        Username: username,
        Email: email,
        Phone: phone,
        Password: password,
        ConfirmPassword: confirmPassword,
        Departament: departament ? departament : null,
        Position: position ? position : null,
        GroupId: groupId,
        Active: true,
      });  
      
      displayToast(
        "success",
        "Informação",
        response.successMessages[0],
        false,
        3000
      );
      
      setLoading(false);
    } catch (err) {
      setLoading(false);
    }
  };  

  return ( 
      <div className={`${styled.wrapper} p-fluid`}> 
      <div className={`${styled.contentWrapper} p-fluid`}>
        <div className={styled.column}>
          <div className={styled.textWrapper}>
            <div className={styled.heading}>{translateMessage("newUser")}</div>
            <div className={styled.subtitle}>{translateMessage("requiredFields")}</div>
          </div>
          <div className="grid col-12"> 
              <form onSubmit={handleSubmit(onSubmit)} className="p-fluid"> 
                <div className="col-12">
                  <span>{t("email")} *</span>
                  <InputText required name="email" onChange={(e) => setEmail(e.target.value)} />
                </div> 
                <div className="col-12">
                  <span>{t("username")} *</span>
                  <InputText required name="userName" onChange={(e) => setUsername(e.target.value)} />
                </div>
                <div className="col-12">
                  <span>{t("name")} *</span>
                  <InputText required name="name" onChange={(e) => setName(e.target.value)} />
                </div> 
                <div className="col-12">
                  <span>{t("phone")} *</span>
                  <InputText required name="phone" onChange={(e) => setPhone(e.target.value)} />
                </div>
                <div className="col-12">
                  <span>{t("password")} *</span>
                  <InputText required  name="password" onChange={(e) => setPassword(e.target.value)} />
                </div> 
                <div className="col-12">
                  <span>{t("confirmPassword")} *</span>
                  <InputText required name="confirmPassword" onChange={(e) => setConfirmPassword(e.target.value)} />
                </div>
                {loading ? (
                <div className="d-flex justify-content-center">
                  <ProgressSpinner style={{width: '50px', height: '50px'}} strokeWidth="8" fill="white" animationDuration=".5s" />
                </div>
                
              ) : (
                <Button
                  type="submit"
                  label={t("confirm")}
                  className={styled.submit}
                />
              )} 
              </form> 
            </div> 
        </div> 
                <div className="col-12">
                  <span>{t("departament")}</span>
                  <InputText name="departament" onChange={(e) => setDepartament(e.target.value)} />
                </div>
                <div className="col-12">
                  <span>{t("position")}</span>
                  <InputText name="position" onChange={(e) => setPosition(e.target.value)} />
                </div>
                <div className="col-12">
                  <span>{t("groupId")} *</span>
                  <InputText required name="groupId" onChange={(e) => setGroupId(e.target.value)} />
                </div>
      </div>
    </div> 
  );
};

export default Register;
